import { Component, Input, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { GetExternalUserRequest, LoginResponse } from 'KiaLearn.Common/angular-common-libraries/projects/web-api-client/src/lib/generated/kia-authentication-api-client';
import { Subscription } from 'rxjs';
import { ThemeModeService } from 'src/app/_metronic/partials/layout/theme-mode-switcher/theme-mode.service';
import { APIService } from 'src/app/api';
import { AuthService } from '../../services/auth.service';
import { environment } from 'src/environments/environment';
import { RecaptchaComponent } from 'ng-recaptcha';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-user-registration-step1',
  templateUrl: './user-registration-step1.component.html',
  styleUrls: ['./user-registration-step1.component.scss']
})
export class UserRegistrationStep1Component {
  @Input() title: string;
  @Input() flowKey: string;
  @ViewChild('recaptcha') recaptchaComponent: RecaptchaComponent;
  
  emailForm: FormGroup;
  darkMode: boolean = false;
  private subscriptions: Subscription[] = [];
  recaptchaResponse: string | null = null;
  recaptchaSiteKey = environment.recaptchaSiteKey;
  isSubmitting: boolean = false;
  recaptchaError: string | null = null;

  constructor(
    public modal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private modeService: ThemeModeService,
    private apiService: APIService,
    private authService: AuthService,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
    this.emailForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      recaptcha: ['', Validators.required]
    });

    this.subscriptions.push(this.modeService.mode.asObservable().subscribe((mode) => {
      this.darkMode = mode === 'dark';
    }));
  }

  onRecaptchaResolved(event: any): void {
    if (event && typeof event === 'string') {
      this.recaptchaResponse = event;
      this.emailForm.get('recaptcha')?.setValue(event);
      this.recaptchaError = null;
    }
  }

  submitEmail(): void {
    if (this.emailForm.valid && this.recaptchaResponse && !this.isSubmitting) {

      this.isSubmitting = true;
      this.recaptchaError = null;
      
      const email = this.emailForm.get('email')?.value;
      const flowString = sessionStorage.getItem(this.flowKey);
      
      if (flowString) {
        const flow = JSON.parse(flowString);
        
        const request : GetExternalUserRequest = new GetExternalUserRequest();
        request.email = email;
        request.accessKey = flow.accessKey;
        request.recaptchaResponse = this.recaptchaResponse;
        
        this.apiService.getKiaAuthenticationApiClient().getUserByAccountKey(request)
          .then((result: LoginResponse) => {
            // User is found and associated with the site -> log in the user
            this.authService.loginWithAccessKey(email, result, flow.accessKey);
            this.modal.close(true);
          })
          .catch((error) => {
            if (error.status === 400) {
              // reCAPTCHA verification failed
              this.recaptchaError = 'Security verification failed. Please try again.';
              this.recaptchaComponent.reset();
            } else if(error.status === 404) {
              // User Not Found, continue with step 2
              flow.email = email;
              flow.step = 2; // Move to next step
              sessionStorage.setItem(this.flowKey, JSON.stringify(flow));
              this.modal.close(false);
            }
            else {
              this.toastr.error("An unexpected error occcured", "Failed");
            }
          })
          .finally(() => {
            this.isSubmitting = false;
          });
      } else {
        this.isSubmitting = false;
      }
    }
    else {
      this.toastr.error("Check the errors", "Failed");
    }
  }
}
